export default __webpack_public_path__ + "static/media/2021 spice rack top.47929030.png";